import { render } from "./ManageSupport.vue?vue&type=template&id=21ba03b6&scoped=true"
import script from "./ManageSupport.vue?vue&type=script&lang=js"
export * from "./ManageSupport.vue?vue&type=script&lang=js"

import "./ManageSupport.vue?vue&type=style&index=0&id=21ba03b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ba03b6"]])

export default __exports__